import { render, staticRenderFns } from "./user.vue?vue&type=template&id=65d83a8f&"
import script from "./user.vue?vue&type=script&lang=ts&"
export * from "./user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "user.vue"
export default component.exports